var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndividual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F4B000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 12.967v29.378H31.59c-3.684 0-5.622 2.516-5.82 2.655h-6.54c-.2-.141-2.11-2.655-5.82-2.655H0V10.313h2.637V39.69H13.42c4.12 0 6.414 2.34 6.985 2.654h4.188c.57-.314 2.865-2.654 6.985-2.654h10.784V12.967H45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 38.438a12.624 12.624 0 0 0-5.064-1.05H5.625V5.624h2.609v26.498h3.913c3.555 0 6.463 2.808 6.603 6.315zM31.26 7.5c-2.782 0-5.46.734-7.823 2.138.062.601.093 1.212.093 1.831v27.906c.176-.129.377-.271.606-.423 4.054-2.724 6.848-2.168 15.239-2.168V7.5H31.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 38.438c0-5.093-4.053-9.236-9.034-9.236h-1.278V0c6.39 0 10.312 5.327 10.312 11.874v26.563z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.0ecccd105906f154691614785d1fdeb3.svg";
export { ForwardRef as ReactComponent };